import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {environment} from "../../../../../../../environments/environment";
import {DocumentsService} from "../../../../../../services/document.service";
import {DecimalPipe, NgForOf} from "@angular/common";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import Swal from "sweetalert2";
import { categoriasAlimento } from 'src/app/models/alimento.model';
import { get } from 'http';
import { categoriasSuplementos, marcasSuplementos } from 'src/app/models/suplemento.model';
import { categoriasPreparados } from 'src/app/models/alimento_preparado.model';
import { categoriasPlatillos } from 'src/app/models/platillo.model';
import { Chart, ChartOptions, registerables } from 'chart.js';
import {UtilsService} from "../../../../../../services/utils.service";
declare var $: any;

@Component({
  selector: 'app-registro-alimentos',
  standalone: true,
  imports: [
    NgForOf,
    DecimalPipe,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './registro-alimentos.component.html',
  styleUrl: './registro-alimentos.component.css'
})
export class RegistroAlimentosComponent implements OnInit, OnChanges{
  constructor(
      private documentService: DocumentsService,
      private utilsService: UtilsService
  ) { }
  @Input({required: true}) userInfo: any;
  @Input({required: true}) detallePrograma: any;
  @Input({required: true}) detalleCliente: any;

  env: any = environment
  programaActivo: any;
  semanas: any;
  infoPrograma: any;
  platillosGuia: any;
  platillosGuiaFiltrados: any;
  idSemana: number = 0;
  idDia: number = 0;
  listaAlimentos: any;
  listaSuplementos: any;
  listaAlimentosPreparados: any;
  accordionSelected: 'Desayuno' | 'Snack1' | 'Comida' | 'Snack2' | 'Cena' | '';
  categoriasAlimentos: any = categoriasAlimento;
  marcasSuplementos: any = marcasSuplementos;
  categoriasSuplementos: any = categoriasSuplementos;
  categoriasPreparados: any = [] = categoriasPreparados;
    categoriasPlatillos: any = categoriasPlatillos;
  filtrosAlimentos: any = {
    categoria: '',
    nombre: '',
    propietario: 'todos'
  }
  filtrosSuplementos: any = {
    categoria: '',
    marca: '',
    propietario: 'todos'
  }
  filtroCategoriaPlatillo: string = '';

  alimentoEditando: {
    tipo: 'Desayuno' | 'Snack1' | 'Comida' | 'Snack2' | 'Cena' | null,
    index: number | null,
    porcionOriginal: number | null,
    valoresOriginales: {
      calorias: number,
      carbohidratos: number, 
      proteinas: number,
      grasaTotal: number
    } | null
  } = {
    tipo: null,
    index: null,
    porcionOriginal: null,
    valoresOriginales: null
  };

  alimentoListaEditando: {
    tipo: 'alimento' | 'suplemento' | null,
    index: number | null,
    porcionOriginal: number | null,
    valoresOriginales: {
      calorias: number,
      carbohidratos: number,
      proteinas: number,
      grasaTotal: number
    } | null
  } = {
    tipo: null,
    index: null,
    porcionOriginal: null,
    valoresOriginales: null
  };
  showAlimento = false;
  alimentoImg: any;

  diaActualAttchId: any;

  ngOnInit(): void {
    this.obtieneDetalleProgramaActivo(this.detalleCliente.expediente.programas[0]) //ahorita va hardcode el 0
    this.getAlimentos();
    this.getSuplementos();
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("=========================== onChanges Expediente Desde registro de alimentos=======================================")
    console.log('expediente cliente: ', this.detalleCliente)
    console.log('detalle progra: ', this.detallePrograma)
    if (changes.detallePrograma) {
      //agregar logica para saber cual es el programa activo, ahora se deja hardcode el primero del array
      this.programaActivo = this.detalleCliente.expediente.programas[0]
      console.log('programa activo: ', this.programaActivo.configuracionMacrosXdia)
    }
  }

  getAlimentos() 
  {
    const filters: any = {
      // "documentContainerId": this.userInfo.documentContainerId,
      // "empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);
    
    if(this.filtrosAlimentos.categoria != '') {
      filtersQuery.push({
        "match_phrase": {
          "categoria.keyword": this.filtrosAlimentos.categoria
        }
      });
    }
    if(this.filtrosAlimentos.nombre != '') {
      filtersQuery.push({
        "match_phrase": {
          "nombre.keyword": this.filtrosAlimentos.nombre
        }
      });
    }
    let should: any = []
    switch (this.filtrosAlimentos.propietario){
      case 'todos':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          },
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env.empresaBaseId
            }
          }
        ]
        break;
      case 'empresaBase':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env.empresaBaseId
            }
          }
        ]
        break;
      case 'propios':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          }
        ]
        break;
    }
    filtersQuery.push(
        {
          "bool": { should }
        }
    )
    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(this.env.businessId, 'alimento', query).subscribe({
        next: (data: any) => {
          console.log(data)
          this.listaAlimentos = data;
        },
        error: (error: any) => {
          console.error(error);
        }
      });
    }, 1000);
  }
  
  getSuplementos()
  {
    const filters: any = {
      // "documentContainerId": this.userInfo.documentContainerId,
      // "empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);
    
    if(this.filtrosSuplementos.categoria != '') {
      filtersQuery.push({
        "match_phrase": {
          "categoria.keyword": this.filtrosSuplementos.categoria
        }
      });
    }
    if(this.filtrosSuplementos.marca != '') {
      filtersQuery.push({
        "match_phrase": {
          "marca.keyword": this.filtrosSuplementos.marca
        }
      });
    }
    let should: any = []
    switch (this.filtrosSuplementos.propietario){
      case 'todos':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          },
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env['empresaBaseId']
            }
          }
        ]
        break;
      case 'empresaBase':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env['empresaBaseId']
            }
          }
        ]
        break;
      case 'propios':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          }
        ]
        break;
    }
    filtersQuery.push(
      {"bool": { should }}
    )
    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(environment.businessId, 'suplemento', query).subscribe({
        next: (data: any) => {
          console.log('suplementos', data)
          this.listaSuplementos = data;
        },
        error: (error: any) => {
          console.error(error);
        }
      });
    }, 1500);
  }

  seccionMacros: 'MetaDia' | 'MacrosRestantesDia' | 'BalanceSemanal' = 'MetaDia';
  changeSeccionMacros(value: 'MetaDia' | 'MacrosRestantesDia' | 'BalanceSemanal') {
    this.seccionMacros = value;
  }

  obtieneDetalleProgramaActivo(programa: any){
      let programaId = programa.configuracionPrograma.id
      this.documentService.getDocumentById(environment.businessId, this.userInfo.documentContainerId, programaId).subscribe((res: any) => {
        console.log('detallePrograma', res)
        this.infoPrograma = res;
        this.generateCalendar()
        if(res.tipo == '2') this.getGuia(res.guiaSeleccionada)
        if(res.tipo == '1') this.getGuia(this.detalleCliente.expediente.programas[0].configuracionPrograma.guiaSeleccionada)
      }, err => {
        console.error(err)
      })
  }

  
  generateCalendar(): void {
    this.documentService.getAttachmentByType(environment.businessId, this.detalleCliente.documentId, 'alimentosDiaCliente').subscribe((res: any) => {
      console.log('alimentosDiaCliente', res.content)
      let alimentacionDias: any = res.content

      this.semanas = [];
      const hoy = new Date();
      let diaEncontrado = false;
      let programaActivo = false;

      for(let i in this.detalleCliente.expediente.programas) {
        let currentDay = 1;
        // Verificar si el programa está activo
        const fechaInicio = new Date(this.detalleCliente.expediente.programas[i].periodos[0].fechaInicioDate);
        const fechaFin = new Date(this.detalleCliente.expediente.programas[i].periodos[this.detalleCliente.expediente.programas[i].periodos.length - 1].fechaFinDate);
        if (hoy >= fechaInicio && hoy <= fechaFin) programaActivo = true;

        for (let periodo of this.detalleCliente.expediente.programas[i].periodos) {
          const fechaInicio = new Date(periodo.fechaInicioDate);
          const fechaFin = new Date(periodo.fechaFinDate);
          let semana = [];
          let diaActual = new Date(fechaInicio);

          while (diaActual <= fechaFin) {
            // Busca la configuración de macros del día actual
            let indexOfMacro = this.detalleCliente.expediente.programas[i].configuracionMacrosXdia.findIndex((item) => item.dia == currentDay);
            if(indexOfMacro != -1){
              // Busca el detalle de alimentos del día actual
              const indexOfStevie = alimentacionDias.map(e => e.dia).indexOf(this.detalleCliente.expediente.programas[i].configuracionMacrosXdia[indexOfMacro].dia);
              if (indexOfStevie !== -1) {
                semana.push({
                  idPrograma: this.detalleCliente.expediente.programas[i].configuracionPrograma.id,
                  dia: currentDay,
                  fechaDate: new Date(diaActual),
                  fecha: this.formatearFecha(diaActual),
                  periodo: periodo.periodo,
                  programaActivo: programaActivo,
                  detalle: alimentacionDias[indexOfStevie]
                });
              }else{
                semana.push({
                  dia: currentDay,
                  fechaDate: new Date(diaActual),
                  fecha: this.formatearFecha(diaActual),
                  periodo: periodo.periodo,
                  programaActivo: programaActivo,
                  detalle: {
                    alimentosDesayuno: [],
                    alimentosSnack1: [],
                    alimentosComida: [],
                    alimentosSnack2: [],
                    alimentosCena: [],
                    suplementos: []
                  }
                });
              }
            }
            if (this.formatearFecha(diaActual) == this.formatearFecha(hoy) && !diaEncontrado) {
              diaEncontrado = true;
              this.idSemana = this.semanas.length;
              this.idDia = semana.length - 1;
            }
            if (diaActual.getDay() === 0) { // Domingo
              this.semanas.push(semana);
              semana = [];
            }
            diaActual.setDate(diaActual.getDate() + 1);
            currentDay++;
          }
          if (semana.length > 0) {
            this.semanas.push(semana);
          }
        }
      }
      for(let i in this.semanas){
        for(let j in this.semanas[i]){
          for(let programa of this.detalleCliente.expediente.programas) {
            let indexDia = programa.configuracionMacrosXdia.findIndex((item) => item.dia == this.semanas[i][j].dia && this.semanas[i][j].fecha == item.fecha);
            if(indexDia != -1){
              let objetivoCaloriasDia: any = {}
              // this.semanas[i][j].configuracionMacrosXdia = programa.configuracionMacrosXdia[indexDia];
              this.semanas[i][j].periodo = programa.configuracionMacrosXdia[indexDia].periodo;
              this.semanas[i][j].idPrograma = programa.configuracionPrograma.id;

              objetivoCaloriasDia.calorias = programa.configuracionMacrosXdia[indexDia].calorias;
              objetivoCaloriasDia.carbsGramos = programa.configuracionMacrosXdia[indexDia].carbsGramos;
              objetivoCaloriasDia.carbsPorcentaje = programa.configuracionMacrosXdia[indexDia].carbsPorcentaje;
              objetivoCaloriasDia.proteGramos = programa.configuracionMacrosXdia[indexDia].proteGramos;
              objetivoCaloriasDia.protePorcentaje = programa.configuracionMacrosXdia[indexDia].protePorcentaje;
              objetivoCaloriasDia.grasaGramos = programa.configuracionMacrosXdia[indexDia].grasaGramos;
              objetivoCaloriasDia.grasaPorcentaje = programa.configuracionMacrosXdia[indexDia].grasaPorcentaje;
              this.semanas[i][j].objetivoCaloriasDia = objetivoCaloriasDia;
              this.semanas[i][j].planSuplementacion = programa.configuracionMacrosXdia[indexDia].planSuplementacion;
              this.calcularMacrosRestantesDia(i, j);
              this.calcularBalanceSemanal(i, j);
            }
          }
        }
      }
      console.log('semanas', this.semanas);
      // console.log('idSemana', this.idSemana);
      // console.log('semanA', this.semanas[this.idSemana]);
      this.detalleDia = this.semanas[this.idSemana][this.idDia];

      if(typeof this.detalleDia.detalle['attachmentId'] != 'undefined'){
        this.diaActualAttchId = this.detalleDia.detalle['attachmentId']
        console.log('actualiza')
        console.log(this.detalleDia.dia + ' = ' +this.diaActualAttchId)
      }else{
        this.crearDiaAlimentos(this.detalleDia)
      }
      // console.log('detalleDia', this.detalleDia)
    }, err => {
      console.error(err)
    })
  }
  isSuplementoSeleccionado(suplemento): boolean {
    return this.semanas[this.idSemana][this.idDia].detalle.suplementos.some(s => s.nombre === suplemento.nombre);
  }
  // Método para formatear la fecha en dd-mm-aaaa
  formatearFecha(fecha: Date): string {
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const anio = fecha.getFullYear();
    return `${dia}-${mes}-${anio}`;
  }
  calcularMacrosRestantesDia(i, j) {
    const comidas = [
      'alimentosDesayuno',
      'alimentosSnack1',
      'alimentosComida',
      'alimentosSnack2',
      'alimentosCena'
    ];
    let totalMacrosPorDia = {
      calorias: 0,
      carbohidratos: 0,
      proteinas: 0,
      grasas: 0
    };
    comidas.forEach(comida => {
      this.semanas[i][j].detalle[comida].forEach(alimento => {
        totalMacrosPorDia.calorias += alimento.calorias;
        totalMacrosPorDia.carbohidratos += alimento.carbohidratos;
        totalMacrosPorDia.proteinas += alimento.proteinas;
        totalMacrosPorDia.grasas += alimento.grasaTotal;
      });
    });

    const objetivo = this.semanas[i][j].objetivoCaloriasDia;
    let macrosRestantesDia = {
      calorias: objetivo.calorias - totalMacrosPorDia.calorias,
      carbohidratos: objetivo.carbsGramos - totalMacrosPorDia.carbohidratos,
      proteinas: objetivo.proteGramos - totalMacrosPorDia.proteinas,
      grasas: objetivo.grasaGramos - totalMacrosPorDia.grasas
    };
    this.semanas[i][j].macrosRestantesDia = macrosRestantesDia;
  }
  calcularBalanceSemanal(i, j): any {
    let balanceSemanal = {
      calorias: 0,
      carbohidratos: 0,
      proteinas: 0,
      grasas: 0
    };
    for(let jDia=0; jDia<=j; jDia++){
      balanceSemanal.calorias += this.semanas[i][jDia].macrosRestantesDia.calorias;
      balanceSemanal.carbohidratos += this.semanas[i][jDia].macrosRestantesDia.carbohidratos;
      balanceSemanal.proteinas += this.semanas[i][jDia].macrosRestantesDia.proteinas;
      balanceSemanal.grasas += this.semanas[i][jDia].macrosRestantesDia.grasas;
    }
    this.semanas[i][j].balanceSemanal = balanceSemanal;
  }
  onChangeIdSemana(value: 1 | -1) {
    this.idSemana = this.idSemana + value;
    this.detalleDia = this.semanas[this.idSemana][this.idDia];
    if(typeof this.detalleDia.detalle['attachmentId'] != 'undefined'){
      this.diaActualAttchId = this.detalleDia.detalle['attachmentId']
      console.log('actualiza')
      console.log(this.detalleDia.dia)
      console.log(this.detalleDia.dia + ' = ' +this.diaActualAttchId)
    }else{
      this.crearDiaAlimentos(this.detalleDia)
    }
  }
  detalleDia: any
  selectDia(detalleDia, j) {
    this.detalleDia = detalleDia;
    this.idDia = j
    if(typeof detalleDia.detalle['attachmentId'] != 'undefined'){
      this.diaActualAttchId = detalleDia.detalle['attachmentId']
      console.log('actualiza')
      console.log(this.detalleDia.dia + ' = ' +this.diaActualAttchId)
    }else{
      this.crearDiaAlimentos(detalleDia)
    }
  }
  crearDiaAlimentos(detalleDia){
    let obj: any = {}
    let attchId = this.utilsService.create_UUID()
    obj = {
      "attachmentId": attchId,
      "programaId": detalleDia.idPrograma,
      "documentId": this.detalleCliente.documentId,
      "dia": detalleDia.dia,
      "fecha": detalleDia.fecha,
      "periodo": detalleDia.periodo,
      "alimentosDesayuno": [],
      "alimentosSnack1": [],
      "alimentosComida": [],
      "alimentosSnack2": [],
      "alimentosCena": [],
      "suplementos": []
    }

    this.detalleDia.detalle['attachmentId'] = attchId
    this.documentService.createDocumentAttachment(
        environment.businessId,
        this.detalleCliente.documentId,
        attchId,
        'alimentosDiaCliente',
        null,
        obj
    ).subscribe({
      next: (response: any) => {
        // this.entrenadores.push(response);
        console.log(response)
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        console.log('complete')
      }
    })

  }
  selectAccordion(value: 'Desayuno' | 'Snack1' | 'Comida' | 'Snack2' | 'Cena') {
    this.accordionSelected = value == this.accordionSelected ? null : value;
    console.log(this.accordionSelected)
  }
  agregarAlimentoSuplemento(alimentos) {
    // console.log(alimentos)
    let alimento = {
      azucar: alimentos.azucar,
      businessId: alimentos.businessId,
      calorias: alimentos.calorias,
      carbohidratos: alimentos.carbohidratos,
      // categoria: alimentos.categoria,
      documentContainerId: alimentos.documentContainerId,
      documentId: alimentos.documentId,
      documentType: alimentos.documentType,
      empresaId: alimentos.empresaId,
      fibra: alimentos.fibra,
      grasaMonoinsaturada: alimentos.grasaMonoinsaturada,
      grasaPoliinsaturada: alimentos.grasaPoliinsaturada,
      grasaSaturada: alimentos.grasaSaturada,
      grasaTotal: alimentos.grasaTotal,
      grasaTrans: alimentos.grasaTrans,
      imagen: alimentos.imagen,
      imagenEtiqueta: alimentos.imagenEtiqueta,
      informacion: alimentos.informacion,
      marca: alimentos.marca,
      nombre: alimentos.nombre,
      porcion: alimentos.porcion,
      proteinas: alimentos.proteinas,
      propietario: alimentos.documentContainerId,
      super: alimentos.super,
      unidad: alimentos.unidad,
    }
    if(this.accordionSelected == 'Desayuno') this.semanas[this.idSemana][this.idDia].detalle.alimentosDesayuno.push(alimento)
    if(this.accordionSelected == 'Snack1') this.semanas[this.idSemana][this.idDia].detalle.alimentosSnack1.push(alimento)
    if(this.accordionSelected == 'Comida') this.semanas[this.idSemana][this.idDia].detalle.alimentosComida.push(alimento)
    if(this.accordionSelected == 'Snack2') this.semanas[this.idSemana][this.idDia].detalle.alimentosSnack2.push(alimento)
    if(this.accordionSelected == 'Cena') this.semanas[this.idSemana][this.idDia].detalle.alimentosCena.push(alimento)
    
    this.calcularMacrosRestantesDia(this.idSemana, this.idDia)
    this.calcularBalanceSemanal(this.idSemana, this.idDia);

    // this.semanas[this.idSemana][this.idDia].alimentos.push(alimentos)
    // console.log('semanas', this.semanas)

    let objDia: any = {}
    objDia = this.semanas[this.idSemana][this.idDia].detalle
    objDia.programaId = this.detalleDia.idPrograma
    objDia.dia = this.detalleDia.dia
    objDia.periodo = this.detalleDia.periodo
    objDia.documentId = this.detalleCliente.documentId

    console.log(objDia)

    this.updateClienteAttch(objDia)

    // this.updateClienteDocument();
  }
  
  cambiarEstadoSuplemento(suplemento){
    let index = this.semanas[this.idSemana][this.idDia].detalle.suplementos.findIndex((item) => item.nombre == suplemento.nombre);
    if(index == -1){
      this.semanas[this.idSemana][this.idDia].detalle.suplementos.push(suplemento);
    } else {
      this.semanas[this.idSemana][this.idDia].detalle.suplementos.splice(index, 1);
    }

    let objDia: any = {}
    objDia = this.semanas[this.idSemana][this.idDia].detalle
    objDia.programaId = this.detalleDia.idPrograma
    objDia.dia = this.detalleDia.dia
    objDia.periodo = this.detalleDia.periodo
    objDia.documentId = this.detalleCliente.documentId

    console.log(objDia)

    this.updateClienteAttch(objDia)

    //this.updateClienteDocument();
  }

  agregarDetalleDePLatillo(detallePlatillo){
    console.log(detallePlatillo)
    for(let alimento of detallePlatillo){
      if(this.accordionSelected == 'Desayuno') this.semanas[this.idSemana][this.idDia].detalle.alimentosDesayuno.push(alimento)
      if(this.accordionSelected == 'Snack1') this.semanas[this.idSemana][this.idDia].detalle.alimentosSnack1.push(alimento)
      if(this.accordionSelected == 'Comida') this.semanas[this.idSemana][this.idDia].detalle.alimentosComida.push(alimento)
      if(this.accordionSelected == 'Snack2') this.semanas[this.idSemana][this.idDia].detalle.alimentosSnack2.push(alimento)
      if(this.accordionSelected == 'Cena') this.semanas[this.idSemana][this.idDia].detalle.alimentosCena.push(alimento)
    }
    // console.log('semanas', this.semanas)
    this.calcularMacrosRestantesDia(this.idSemana, this.idDia)
    this.calcularBalanceSemanal(this.idSemana, this.idDia);

    let objDia: any = {}
    objDia = this.semanas[this.idSemana][this.idDia].detalle
    objDia.programaId = this.detalleDia.idPrograma
    objDia.dia = this.detalleDia.dia
    objDia.periodo = this.detalleDia.periodo
    objDia.documentId = this.detalleCliente.documentId

    console.log(objDia)

    this.updateClienteAttch(objDia)
    //this.updateClienteDocument();
  }
  eliminarAlimentoSuplemento(tipo: 'Desayuno'|'Snack1'|'Comida'|'Snack2'|'Cena', index){
    if(tipo == 'Desayuno') this.semanas[this.idSemana][this.idDia].detalle.alimentosDesayuno.splice(index, 1)
    if(tipo == 'Snack1') this.semanas[this.idSemana][this.idDia].detalle.alimentosSnack1.splice(index, 1)
    if(tipo == 'Comida') this.semanas[this.idSemana][this.idDia].detalle.alimentosComida.splice(index, 1)
    if(tipo == 'Snack2') this.semanas[this.idSemana][this.idDia].detalle.alimentosSnack2.splice(index, 1)
    if(tipo == 'Cena') this.semanas[this.idSemana][this.idDia].detalle.alimentosCena.splice(index, 1)
    this.calcularMacrosRestantesDia(this.idSemana, this.idDia)
    this.calcularBalanceSemanal(this.idSemana, this.idDia);

    let objDia: any = {}
    objDia = this.semanas[this.idSemana][this.idDia].detalle
    objDia.programaId = this.detalleDia.idPrograma
    objDia.dia = this.detalleDia.dia
    objDia.periodo = this.detalleDia.periodo
    objDia.documentId = this.detalleCliente.documentId

    console.log(objDia)

    this.updateClienteAttch(objDia)
    //this.updateClienteDocument();
  }

  updateClienteAttch(objDia){

    this.documentService.updateDocumentAttachment(
        environment.businessId,
        this.detalleCliente.documentId,
        objDia.attachmentId,
        'alimentosDiaCliente',
        null,
        objDia
    ).subscribe({
      next: (response: any) => {
        console.log(response)
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        console.log('complete')
      }
    })
  }

  updateClienteDocument() {
    const index = this.detalleCliente.expediente.programas.findIndex((item) => item.configuracionPrograma.id === this.semanas[this.idSemana][this.idDia].idPrograma);
    let programas = [...this.detalleCliente.expediente.programas];

    let alimentacion = [];
    for(let i in this.semanas){
      for(let j in this.semanas[i]){
        if(this.semanas[i][j].idPrograma == this.semanas[this.idSemana][this.idDia].idPrograma){
          let detalle = {
            dia: this.semanas[i][j].dia,
            fecha: this.semanas[i][j].fecha,
            periodo: this.semanas[i][j].periodo,
            alimentosDesayuno: this.semanas[i][j].detalle.alimentosDesayuno,
            alimentosSnack1: this.semanas[i][j].detalle.alimentosSnack1,
            alimentosComida: this.semanas[i][j].detalle.alimentosComida,
            alimentosSnack2: this.semanas[i][j].detalle.alimentosSnack2,
            alimentosCena: this.semanas[i][j].detalle.alimentosCena,
            suplementos: this.semanas[i][j].detalle.suplementos
          }
          alimentacion.push(detalle)
        }
      }
    }

    programas[index].alimentacion = alimentacion
    let expedienteClienteDocument: any = {
      expediente: { 
        programas: programas
      }
    }
    console.log('expedienteClienteDocument', expedienteClienteDocument)
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.detalleCliente.documentId,
      "cliente",
      null,
      expedienteClienteDocument
    ).subscribe({
      next: (data: any) => {
        console.log(data);
      },
      error: (error: any) => {
        console.log(error);
      },
      complete: () => {
        // Swal.fire({
        //   toast: true, // Activa el estilo tipo Toast
        //   position: 'bottom-end', // Posición del mensaje
        //   icon: 'success',
        //   title: 'La información del programa ha sido actualizada.',
        //   showConfirmButton: false,
        //   timer: 5000, // Tiempo de duración del mensaje (5 segundos)
        //   timerProgressBar: true // Muestra una barra de progreso
        // });

        // Emitir el evento hacia el padre
        // this.programaClienteActualizado.emit();
      }
    })
  }

  getGuia(guiaSeleccionada: any){
    // debugger
    let documentId = guiaSeleccionada.documentId
    this.documentService.getDocumentById(environment.businessId, this.userInfo.documentContainerId, documentId).subscribe((res: any) => {
      console.log('Guia', res)
      this.platillosGuia = res.detalle;
      this.platillosGuiaFiltrados = [...this.platillosGuia]
    }, err => {
      console.error(err)
    })
  }
  filtrarPlatillos(){
    if(this.filtroCategoriaPlatillo != '') {
      this.platillosGuiaFiltrados = this.platillosGuia.filter((platillo) => {
        return platillo.categoria == this.filtroCategoriaPlatillo
      })
    } else {
      this.platillosGuiaFiltrados = [...this.platillosGuia];
    }
  }

  /* Métodos para editar cantidad de alimentos en el detalle del día */
  editarCantidad(tipo: 'Desayuno' | 'Snack1' | 'Comida' | 'Snack2' | 'Cena', index: number) {
    const alimento = this.semanas[this.idSemana][this.idDia].detalle[`alimentos${tipo}`][index];
    
    this.alimentoEditando = {
      tipo,
      index,
      porcionOriginal: alimento.porcion,
      valoresOriginales: {
        calorias: alimento.calorias,
        carbohidratos: alimento.carbohidratos,
        proteinas: alimento.proteinas,
        grasaTotal: alimento.grasaTotal
      }
    };

    setTimeout(() => {
      $('.editar-cantidad').focus()
    }, 500);
  }
  actualizarCantidad(event: any, confirmar: boolean = false) {
    if (!this.alimentoEditando.tipo || this.alimentoEditando.index === null) return;

    const nuevaCantidad = parseFloat(event.target.value);
    if (isNaN(nuevaCantidad)) return;
    if (nuevaCantidad <= 0) return;

    const alimento = this.semanas[this.idSemana][this.idDia].detalle[`alimentos${this.alimentoEditando.tipo}`][this.alimentoEditando.index];
    const factor = nuevaCantidad / this.alimentoEditando.porcionOriginal;

    // Actualizar valores proporcionalmente
    alimento.porcion = nuevaCantidad;
    alimento.calorias = +(this.alimentoEditando.valoresOriginales.calorias * factor);
    alimento.carbohidratos = +(this.alimentoEditando.valoresOriginales.carbohidratos * factor);
    alimento.proteinas = +(this.alimentoEditando.valoresOriginales.proteinas * factor);
    alimento.grasaTotal = +(this.alimentoEditando.valoresOriginales.grasaTotal * factor);

    // Recalcular macros
    this.calcularMacrosRestantesDia(this.idSemana, this.idDia);
    this.calcularBalanceSemanal(this.idSemana, this.idDia);

    let objDia: any = {}
    objDia = this.semanas[this.idSemana][this.idDia].detalle
    objDia.programaId = this.detalleDia.idPrograma
    objDia.dia = this.detalleDia.dia
    objDia.periodo = this.detalleDia.periodo
    objDia.documentId = this.detalleCliente.documentId
    
    // Solo actualizar en BD y resetear estado cuando se confirma el cambio
    if (confirmar) {
      //this.updateClienteDocument();

      this.updateClienteAttch(objDia)
      this.alimentoEditando = {
        tipo: null,
        index: null,
        porcionOriginal: null,
        valoresOriginales: null
      };
    }
  }

  /* Métodos para editar cantidad de alimentos en la lista */
  editarCantidadLista(tipo: 'alimento' | 'suplemento', index: number) {
    const item = tipo === 'alimento' ? this.listaAlimentos[index] : this.listaSuplementos[index];
    
    this.alimentoListaEditando = {
      tipo,
      index,
      porcionOriginal: item.porcion,
      valoresOriginales: {
        calorias: item.calorias,
        carbohidratos: item.carbohidratos,
        proteinas: item.proteinas,
        grasaTotal: item.grasaTotal
      }
    };
    setTimeout(() => {
      $('.editar-cantidad-lista').focus()
    }, 500);
  }
  actualizarCantidadLista(event: any, confirmar: boolean = false) {
    if (!this.alimentoListaEditando.tipo || this.alimentoListaEditando.index === null) return;

    const nuevaCantidad = parseFloat(event.target.value);
    if (isNaN(nuevaCantidad)) return;
    if (nuevaCantidad <= 0) return;

    const lista = this.alimentoListaEditando.tipo === 'alimento' ? this.listaAlimentos : this.listaSuplementos;
    const item = lista[this.alimentoListaEditando.index];
    const factor = nuevaCantidad / this.alimentoListaEditando.porcionOriginal;

    // Actualizar valores proporcionalmente
    item.porcion = nuevaCantidad;
    item.calorias = +(this.alimentoListaEditando.valoresOriginales.calorias * factor).toFixed(1);
    item.carbohidratos = +(this.alimentoListaEditando.valoresOriginales.carbohidratos * factor).toFixed(1);
    item.proteinas = +(this.alimentoListaEditando.valoresOriginales.proteinas * factor).toFixed(1);
    item.grasaTotal = +(this.alimentoListaEditando.valoresOriginales.grasaTotal * factor).toFixed(1);

    // Resetear estado cuando se confirma el cambio
    if (confirmar) {
      this.alimentoListaEditando = {
        tipo: null,
        index: null,
        porcionOriginal: null,
        valoresOriginales: null
      };
    }
  }

  mostrarImagenAlimento(imagen){
    this.showAlimento = true;
    this.alimentoImg = imagen
  }

  returnMostrarImagenAlimento(){
    this.showAlimento = false;
  }


   /*************** DETALLE PLATILLO ***************/
   detallePlatillo: any = {};
   chartPlatilloInstance: Chart | null = null;
   modalDetallePlatilo(platillo)
   {
     console.log(platillo)
     this.detallePlatillo = platillo;
 
     let caloriasPlatillo = platillo.calorias;
     let carbohidratosPlatillo = platillo.carbohidratos;
     let proteinasPlatillo = platillo.proteinas;
     let grasasPlatillo = platillo.grasas;
   
     // Calcula el porcentaje de cada macronutriente
     let porcentajeCarbohidratos = ((carbohidratosPlatillo * 4) / caloriasPlatillo) * 100 || 0;
     let porcentajeProteinas = ((proteinasPlatillo * 4) / caloriasPlatillo) * 100 || 0;
     let porcentajeGrasas = ((grasasPlatillo * 9) / caloriasPlatillo) * 100 || 0;
 
     // Ajusta los porcentajes para que sumen 100%
     let sumaPorcentajes = porcentajeCarbohidratos + porcentajeProteinas + porcentajeGrasas;
     porcentajeCarbohidratos = (porcentajeCarbohidratos / sumaPorcentajes) * 100;
     porcentajeProteinas = (porcentajeProteinas / sumaPorcentajes) * 100;
     porcentajeGrasas = (porcentajeGrasas / sumaPorcentajes) * 100;
   
     // Crea el gráfico con los porcentajes calculados
     this.createPieChartPlatillo('pieChartDetallePlatillo', porcentajeCarbohidratos, porcentajeProteinas, porcentajeGrasas);
 
     $("#modal-detallePlatillo").modal('show');
   }

   createPieChartPlatillo(htmlId:string, pCarbohidratos: number, pProteinas: number, pGrasas: number): void {
    const ctx = document.getElementById(htmlId) as HTMLCanvasElement;

    // Destruye el gráfico anterior si existe
    if (this.chartPlatilloInstance) {
      this.chartPlatilloInstance.destroy();
    }

    // Crea un nuevo gráfico y almacena la instancia
    this.chartPlatilloInstance = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: [
          `Carbohidratos - ${pCarbohidratos.toFixed(2)}%`,
          `Proteínas - ${pProteinas.toFixed(2)}%`,
          `Grasas - ${pGrasas.toFixed(2)}%`
        ],
        datasets: [{
          label: '%',
          data: [pCarbohidratos, pProteinas, pGrasas],
          backgroundColor: ['rgb(75, 192, 75)', 'rgb(255, 206, 86)','rgb(243, 78, 78)'],
          borderColor: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          tooltip: {
            enabled: true
          }
        }
      } as ChartOptions
    });
  }
/*
  inicializarGuiaModal()
  {
    // this.getPlatillos(); // Actualiza el listado de platillos
    // this.listaPlatillos = [...this.formPlatillos.get('items').value];
    this.getPlatillos();
    this.constructorGuiaModal.nombre = '';
    this.constructorGuiaModal.platillos = []; 

    this.inicializarDataTablePlatillosModal();
    this.inicializarDataTableConstructorGuiaModal();
  }*/


}
